module.exports = __webpack_public_path__ + "img/texiao-_0000s_0007_8.34460fe6.png";